<template>
    <ModalWrapper dark-scheme @close="closeModal()" modal-size="small">
        <template #modal-header>
            <ModalHeader dark-scheme title="Generate your checklist" />
        </template>
        <template #modal-body>
            <ModalBody text-align="center">
                <div class="generate-checklist-content">
                    <div>Would you like to add the checklist to your existing portfolio or a duplicate version of the same portfolio?</div>
                </div>
            </ModalBody>
        </template>
        <template #modal-footer>
            <ModalFooter>
                <Cta type="secondary" dark-scheme @click="handleEditPortfolio">Existing portfolio</Cta>
                <Cta type="primary" dark-scheme @click="handleDuplicatePortfolio">Duplicate portfolio</Cta>
            </ModalFooter>
        </template>

    </ModalWrapper>

</template>

<script>

import Cta from "../../../common/components/CtaButton.vue";
import ModalWrapper from "../../../sections/modals/_ModalWrapper.vue";
import ModalHeader from "../../../sections/modals/_ModalHeader.vue";
import ModalBody from "../../../sections/modals/_ModalBody.vue";
import ModalFooter from "../../../sections/modals/_ModalFooter.vue";

export default {
    name: 'generate-checklist-modal',
    components: {ModalFooter, ModalBody, ModalHeader, ModalWrapper, Cta},
    emits: ['close', 'edit-portfolio', 'duplicate-portfolio'],
    methods: {
        handleEditPortfolio() {
            this.closeModal();
            this.$emit('edit-portfolio');
        },
        handleDuplicatePortfolio() {
            this.closeModal();
            this.$emit('duplicate-portfolio');
        },
        closeModal() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.generate-checklist-content {
    text-align: center;
}
</style>
